module.exports = __webpack_public_path__ + "img/search_grey_icon.ad139570.svg";